import routes from "@/constants/routes";
import Image from "next/image";
import { useWindowSize } from "@/shared/hooks/useWindowSize";
import Screen from "@/constants/screens";

const ContactBanner = (): JSX.Element => {
  const { width } = useWindowSize();

  const getImageHeight = () => {
    if (width <= Screen.Mobile_640) {
      return 15;
    }
    if (width <= 1279) {
      return 15;
    }
    return 18;
  };
  return (
    <section className="relative z-30 flex flex-col items-center justify-center w-auto text-white rounded-2xl bg-landing-blue mx-4 md:mx-5 lg:mx-20 py-7 md:py-9 lg:py-16">
      <h2 className="text-3xl font-bold text-center xl:text-5xl max-w-[300px] md:max-w-fit">
        Want to learn more about Keyzy?
      </h2>

      <div className="flex flex-col items-center justify-center text-center md:mt-5 md:flex-row">
        <p className="my-6 font-serif text-xl font-normal whitespace-nowrap md:my-auto xl:text-2xl">
          <span>
            <a href="https://wa.me/447707053999" target="_blank" rel="noreferrer">
              {" "}
              <Image
                src="/contact/whatsapp-white.svg"
                alt="Contact us on WhatsApp"
                priority
                width={24}
                height={getImageHeight()}
                className="mr-2"
              />
              <span className="font-serif text-xl font-normal xl:text-2xl ml-1 xl:ml-2 underline">
                Chat with us on WhatsApp
              </span>
            </a>
          </span>
        </p>

        <div className="hidden w-px h-12 bg-white md:mx-4 xl:mx-12 md:inline-block" />

        <p className="font-serif text-xl font-normal xl:text-2xl">Read our FAQs here</p>

        <a
          href={routes.faqs}
          className="min-w-[8rem] flex items-center justify-center w-full h-12 px-4 py-3 mt-4 text-base font-bold transition duration-300 ease-in-out transform rounded-md whitespace-nowrap md:mt-0 md:w-auto bg-landing-orange md:ml-4 xl:ml-9 hover:scale-105 text-landing-blue lg:text-white"
        >
          FAQs
        </a>
      </div>
    </section>
  );
};

export default ContactBanner;
